import script from "./OTabelaAcordeaoProfissionais.vue?vue&type=script&lang=ts&setup=true"
export * from "./OTabelaAcordeaoProfissionais.vue?vue&type=script&lang=ts&setup=true"

import "./OTabelaAcordeaoProfissionais.vue?vue&type=style&index=0&id=75397e46&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75397e46"]])

export default __exports__